export function parseFirstVisitTimestamp(value: string | undefined, now: number): number | null {
  if (!value) {
    return null;
  }
  const timestamp = Number(value);

  return Number.isFinite(timestamp) && timestamp >= 0 && timestamp <= now ? timestamp : null;
}
